// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   ConversationInbox.css
   Unified inbox for WhatsApp + Instagram DM
   ======================================== */

.conversation-inbox {
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
}

/* ── Header ── */
.inbox-header {
    margin-bottom: 20px;
}

.inbox-title-row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;
}

.inbox-title-row h2 {
    margin: 0;
    font-size: 22px;
    color: #333;
}

.inbox-title-row .btn-back {
    background: none;
    border: none;
    color: #667eea;
    cursor: pointer;
    font-size: 14px;
    padding: 4px 8px;
    border-radius: 6px;
    transition: background 0.2s;
}

.inbox-title-row .btn-back:hover {
    background: #f0f2ff;
}

.inbox-stats {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
}

.stat-chip {
    font-size: 13px;
    color: #555;
    background: #f1f3f5;
    padding: 4px 12px;
    border-radius: 16px;
}

.stat-chip.paused {
    background: #fff3cd;
    color: #856404;
}

.stat-chip strong {
    margin-left: 2px;
}

/* ── Filters ── */
.inbox-filters {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

.filter-group {
    display: flex;
    align-items: center;
    gap: 6px;
}

.filter-group label {
    font-size: 13px;
    color: #666;
}

.filter-group select {
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 13px;
    background: white;
    cursor: pointer;
}

.filter-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #666;
    cursor: pointer;
}

.filter-toggle input[type="checkbox"] {
    cursor: pointer;
}

.btn-refresh {
    background: none;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.2s;
}

.btn-refresh:hover {
    background: #f1f3f5;
}

/* ── States ── */
.inbox-loading,
.inbox-error,
.inbox-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #888;
    text-align: center;
}

.inbox-empty i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #ccc;
}

.inbox-error button {
    margin-top: 12px;
    padding: 8px 20px;
    border: 1px solid #667eea;
    background: white;
    color: #667eea;
    border-radius: 8px;
    cursor: pointer;
}

.loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #e0e0e0;
    border-top: 3px solid #667eea;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 12px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* ── Conversation List ── */
.inbox-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    background: #f8f9fa;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.inbox-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 18px;
    background: white;
    cursor: pointer;
    transition: background 0.15s;
}

.inbox-item:hover {
    background: #f0f2ff;
}

.inbox-item.paused {
    border-left: 3px solid #ffc107;
}

/* Left section */
.inbox-item-left {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex: 1 1;
    min-width: 0;
}

.contact-avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #f1f3f5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}

.contact-details {
    flex: 1 1;
    min-width: 0;
}

.contact-name-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 3px;
}

.contact-name {
    font-weight: 600;
    font-size: 14px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.paused-badge {
    font-size: 11px;
    background: #fff3cd;
    color: #856404;
    padding: 1px 8px;
    border-radius: 10px;
    flex-shrink: 0;
}

.contact-preview {
    font-size: 13px;
    color: #888;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 6px;
}

.contact-meta-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

/* Chips */
.platform-chip {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    background: #e9ecef;
    color: #555;
}

.platform-chip.whatsapp {
    background: #dcf8c6;
    color: #25d366;
}

.platform-chip.instagram-dm {
    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);
    color: white;
}

.platform-chip.facebook {
    background: #e7f0ff;
    color: #1877f2;
}

.agent-chip {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    background: #e9ecef;
    color: #666;
    text-transform: capitalize;
}

.sentiment-chip {
    font-size: 10px;
    padding: 2px 8px;
    border-radius: 10px;
    color: white;
    text-transform: capitalize;
}

/* Right section */
.inbox-item-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    flex-shrink: 0;
    margin-left: 12px;
}

.message-time {
    font-size: 12px;
    color: #999;
}

.message-count {
    font-size: 11px;
    color: #888;
    background: #f1f3f5;
    padding: 1px 8px;
    border-radius: 10px;
}

/* ── Responsive ── */
@media (max-width: 600px) {
    .conversation-inbox {
        padding: 12px;
    }

    .inbox-filters {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .inbox-item {
        padding: 10px 12px;
    }

    .contact-avatar {
        width: 36px;
        height: 36px;
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ConversationInbox.css"],"names":[],"mappings":"AAAA;;;6CAG6C;;AAE7C;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;;;IAGI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,8DAA8D;IAC9D,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":["/* ========================================\n   ConversationInbox.css\n   Unified inbox for WhatsApp + Instagram DM\n   ======================================== */\n\n.conversation-inbox {\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n/* ── Header ── */\n.inbox-header {\n    margin-bottom: 20px;\n}\n\n.inbox-title-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 12px;\n}\n\n.inbox-title-row h2 {\n    margin: 0;\n    font-size: 22px;\n    color: #333;\n}\n\n.inbox-title-row .btn-back {\n    background: none;\n    border: none;\n    color: #667eea;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 4px 8px;\n    border-radius: 6px;\n    transition: background 0.2s;\n}\n\n.inbox-title-row .btn-back:hover {\n    background: #f0f2ff;\n}\n\n.inbox-stats {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.stat-chip {\n    font-size: 13px;\n    color: #555;\n    background: #f1f3f5;\n    padding: 4px 12px;\n    border-radius: 16px;\n}\n\n.stat-chip.paused {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.stat-chip strong {\n    margin-left: 2px;\n}\n\n/* ── Filters ── */\n.inbox-filters {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n\n.filter-group {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.filter-group label {\n    font-size: 13px;\n    color: #666;\n}\n\n.filter-group select {\n    padding: 5px 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 13px;\n    background: white;\n    cursor: pointer;\n}\n\n.filter-toggle {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: #666;\n    cursor: pointer;\n}\n\n.filter-toggle input[type=\"checkbox\"] {\n    cursor: pointer;\n}\n\n.btn-refresh {\n    background: none;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 5px 10px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background 0.2s;\n}\n\n.btn-refresh:hover {\n    background: #f1f3f5;\n}\n\n/* ── States ── */\n.inbox-loading,\n.inbox-error,\n.inbox-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n    color: #888;\n    text-align: center;\n}\n\n.inbox-empty i {\n    font-size: 48px;\n    margin-bottom: 12px;\n    color: #ccc;\n}\n\n.inbox-error button {\n    margin-top: 12px;\n    padding: 8px 20px;\n    border: 1px solid #667eea;\n    background: white;\n    color: #667eea;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.loading-spinner {\n    width: 32px;\n    height: 32px;\n    border: 3px solid #e0e0e0;\n    border-top: 3px solid #667eea;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin-bottom: 12px;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* ── Conversation List ── */\n.inbox-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    background: #f8f9fa;\n    border-radius: 12px;\n    overflow: hidden;\n    border: 1px solid #e9ecef;\n}\n\n.inbox-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 18px;\n    background: white;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.inbox-item:hover {\n    background: #f0f2ff;\n}\n\n.inbox-item.paused {\n    border-left: 3px solid #ffc107;\n}\n\n/* Left section */\n.inbox-item-left {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n}\n\n.contact-avatar {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    background: #f1f3f5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    flex-shrink: 0;\n}\n\n.contact-details {\n    flex: 1;\n    min-width: 0;\n}\n\n.contact-name-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 3px;\n}\n\n.contact-name {\n    font-weight: 600;\n    font-size: 14px;\n    color: #333;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.paused-badge {\n    font-size: 11px;\n    background: #fff3cd;\n    color: #856404;\n    padding: 1px 8px;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n.contact-preview {\n    font-size: 13px;\n    color: #888;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: 6px;\n}\n\n.contact-meta-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n/* Chips */\n.platform-chip {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    background: #e9ecef;\n    color: #555;\n}\n\n.platform-chip.whatsapp {\n    background: #dcf8c6;\n    color: #25d366;\n}\n\n.platform-chip.instagram-dm {\n    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);\n    color: white;\n}\n\n.platform-chip.facebook {\n    background: #e7f0ff;\n    color: #1877f2;\n}\n\n.agent-chip {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    background: #e9ecef;\n    color: #666;\n    text-transform: capitalize;\n}\n\n.sentiment-chip {\n    font-size: 10px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    color: white;\n    text-transform: capitalize;\n}\n\n/* Right section */\n.inbox-item-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    flex-shrink: 0;\n    margin-left: 12px;\n}\n\n.message-time {\n    font-size: 12px;\n    color: #999;\n}\n\n.message-count {\n    font-size: 11px;\n    color: #888;\n    background: #f1f3f5;\n    padding: 1px 8px;\n    border-radius: 10px;\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n    .conversation-inbox {\n        padding: 12px;\n    }\n\n    .inbox-filters {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n\n    .inbox-item {\n        padding: 10px 12px;\n    }\n\n    .contact-avatar {\n        width: 36px;\n        height: 36px;\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
